import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// When the prerender step (`yarn prerender`, see `scripts/prerender.mjs`)
// has emitted a static HTML file for this route, the #root element will
// already contain server-rendered DOM. In that case we hydrate it instead
// of replacing it — preserves the SEO-friendly markup that crawlers and
// AI fetchers received in the initial HTTP response.
const container = document.getElementById('root');
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
